module.exports = __webpack_public_path__ + "img/empty.742e31a6.svg";